<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }">
    <i class="fas fa-user mr-1" />
    {{ text }}
  </FilterBadge>
</template>

<script setup lang="ts">
import { gql } from "@apollo/client/core";
import { computed, type PropType } from "vue";
import apolloCache from "@/graphql/apolloCache";
import CreatorFilter from "../../filterImplementations/CreatorFilter";
import FilterBadge from "./FilterBadge.vue";
import joinList from "./joinList";

const props = defineProps({
  filter: {
    type: Object as PropType<CreatorFilter>,
    required: true,
  },
});
const text = computed(() => {
  const usernames = props.filter.creators.map((creatorId) => {
    const { preferredName } = apolloCache.readFragment<{ preferredName: string }>({
      id: `User:${creatorId}`,
      fragment: gql`
        fragment PreferredName on User {
          preferredName
        }
      `,
    }) ?? { preferredName: "Unknown" };
    return preferredName;
  });
  return joinList(usernames);
});
</script>

<style lang="scss" scoped></style>
